import React, { Component } from 'react'
import { breakpoints, style } from 'app/assets/styles'
import type { FilteredRestaurant, RestaurantShortDTO } from 'shared/types'
import Modal from 'react-modal'
import { Content } from './Content'

const { medium } = breakpoints
const { classicModalStyle, classicModalMobileStyle } = style

type Props = {
    isOpen: boolean,
    loading?: boolean,
    fromKingdom?: boolean,
    fromBirthday?: boolean,
    handleClose: () => void,
    restaurants: Array<FilteredRestaurant>,
    addRestaurant: RestaurantShortDTO => void,
    selectRestaurant: RestaurantShortDTO => void,
    selectedRestaurant: RestaurantShortDTO,
    resetAddRestaurantSuccess?: () => void,
    addRestaurantSuccess?: boolean,
    addRestaurantError?: string
}

type State = {
    width: number
}

class RestaurantModal extends Component<Props, State> {
    state = {
        width: window.innerWidth
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateWindowDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions)
    }

    updateWindowDimensions = () => this.setState({ width: window.innerWidth })

    render() {
        const { isOpen, ...otherProps } = this.props
        const { width } = this.state
        const mobile = width < medium - 1

        return (
            <Modal
                shouldCloseOnOverlayClick={false}
                isOpen={isOpen}
                ariaHideApp={false}
                style={mobile ? classicModalMobileStyle : classicModalStyle}>
                <Content desktop={!mobile} {...otherProps} />
            </Modal>
        )
    }
}

export { RestaurantModal }
